import { composeProps, createPropsExtender } from '@mews/framework';
import { getResourceFeaturesByIds } from '../ducks/resourceFeatures';
import { getResourceFeatureAssignmentResourceFeatureIdsByResourceId } from '../ducks/resourceFeatureAssignments';

export const getResourceFeaturesByResourceId = composeProps(
    getResourceFeaturesByIds,
    createPropsExtender('ids', getResourceFeatureAssignmentResourceFeatureIdsByResourceId)
);
